import React, { useEffect, useState } from "react";
import { Grid, Button, Input, Typography, Loading } from "../core";
import { Form, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { MixStyle } from "../styles";
import { updateProfile } from "../helper/utils/api/auth";
import { getProfile as loadProfileAction } from "../redux/Action/auth";

const Container = styled.div`
  background: #233b67;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Wraper = styled.div`
  background: white;
  max-width: 589px;
  margin: auto;
  padding: 20px 0;
`;

const StyledForm = styled(Form)`
  padding: 0px 20px;
  label {
    ${MixStyle.Label};
  }
`;
const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const Profile = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const user = auth?.userDetail;

  useEffect(() => {
    const token = localStorage.getItem("usertoken");
    if (token) {
      dispatch(loadProfileAction({ token }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.name || user.email?.split("@")[0] || "",
        email: user.email || "",
      });
    }
  }, [user, form]);

  const onFinish = async (values) => {
    setIsLoading(true);
    setMessage("");
    try {
      const { data } = await updateProfile(values);
      setMessage(data.message || "Profile updated");
      const token = localStorage.getItem("usertoken");
      if (token) dispatch(loadProfileAction({ token }));
    } catch (error) {
      setMessage(
        error?.response?.data?.message || "Failed to update profile"
      );
    }
    setIsLoading(false);
  };

  return (
    <Container>
      {isLoading ? <Loading /> : null}
      {user ? (
        <Grid>
          <Wraper>
            <StyledForm
              form={form}
              {...layout}
              name="profile"
              onFinish={onFinish}
            >
              <Row gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}>
                <Col xs={24}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: "Please input name" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, message: "Please input email" }]}
                  >
                    <Input type="email" />
                  </Form.Item>
                </Col>
                {message ? (
                  <Col xs={24}>
                    <Typography text={message} as="p" />
                  </Col>
                ) : null}
                <Col xs={24}>
                  <Form.Item>
                    <Button
                      width="187px"
                      bg="#404E67"
                      type="primary"
                      htmlType="submit"
                    >
                      <Typography
                        text="Update"
                        as="h5"
                        noMargin
                        weight="bold"
                        align="center"
                        color="white"
                      />
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </StyledForm>
          </Wraper>
        </Grid>
      ) : (
        <div>Loading.....</div>
      )}
    </Container>
  );
};

export default Profile;
